var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingTools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.5,43c-5.7,0-11.1-2.2-15.2-6.3C2.2,32.6,0,27.2,0,21.5S2.2,10.4,6.3,6.3C10.4,2.2,15.8,0,21.5,0s11.1,2.2,15.2,6.3 c4.1,4.1,6.3,9.5,6.3,15.2s-2.2,11.1-6.3,15.2C32.6,40.8,27.2,43,21.5,43z M21.5,3c-4.9,0-9.6,1.9-13.1,5.4C4.9,11.9,3,16.6,3,21.5 c0,4.9,1.9,9.6,5.4,13.1c3.5,3.5,8.1,5.4,13.1,5.4s9.6-1.9,13.1-5.4c3.5-3.5,5.4-8.1,5.4-13.1c0-4.9-1.9-9.6-5.4-13.1 C31.1,4.9,26.4,3,21.5,3z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3,18.4c0.2-0.5,0.6-0.9,1.1-1.1l12.1-4.8l-4.8,12.1c-0.2,0.5-0.6,0.9-1.1,1.1l-12.1,4.8L17.3,18.4z M19.9,19.9 l-2.1,5.2l5.2-2.1l2.1-5.2L19.9,19.9z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingTools);
export default __webpack_public_path__ + "static/media/shopping_tools.4e6850c40d6f2a907d290521932df956.svg";
export { ForwardRef as ReactComponent };